import { render, staticRenderFns } from "./InclusiveSustainabilityView.vue?vue&type=template&id=63768b6e&scoped=true&"
import script from "./InclusiveSustainabilityView.vue?vue&type=script&lang=js&"
export * from "./InclusiveSustainabilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63768b6e",
  null
  
)

export default component.exports